export const veridionPageDE = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Die Organisation aus KI-Mitarbeitern",
    "description": "Die nächste Stufe der Produktivitätssteigerung: Organisation as a Service. KI-Mitarbeiter integrieren sich in jeden Prozess, lernen eigenständig und erschaffen fehlende Fähigkeiten selbst, on-premises oder in Ihrer Cloud."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Ein Schöpfer, unendlich viele Lösungen.",
    "claim": "Die nächste Stufe der Produktivitätssteigerung: Organisation as a Service.",
    "lead": "Die Firmen-KI, die die gesamte pAIoneer Labs GmbH steuert: eine Belegschaft aus KI-Mitarbeitern, die sich in jeden Prozess Ihres Unternehmens integriert, Arbeit eigenständig zu Ende führt und mit jeder Aufgabe dazulernt. Menschen geben die Richtung vor. Alles andere geschieht von selbst."
  },
  "vision": {
    "lines": [
      "Software gab Unternehmen Werkzeuge.",
      "KI gab ihnen Assistenten.",
      "Veridion gibt ihnen eine Organisation."
    ],
    "note": "Informationen bewegen sich in Stunden, Erfahrung geht in Rente, Stellen bleiben unbesetzt. Noch ein Werkzeug löst das nicht; eine Belegschaft, die man nicht einstellen muss, löst es."
  },
  "grow": {
    "title": "Was es nicht kann, erschafft es selbst",
    "text": "Wo für eine Aufgabe noch keine Fähigkeit existiert oder etwas mit bestehenden Mitteln nicht geht, entwickelt Veridion selbst neue, beliebig komplexe KI-Systeme — KI entwickelt KI eigenständig weiter: entworfen, gebaut, geprüft und in Betrieb genommen. Nur die Freigabe liegt beim Menschen über [Intent-Driven Development](idd) (IDD).",
    "punch": "Genau das heißt: ein Schöpfer, unendlich viele Lösungen."
  },
  "integrate": {
    "title": "Mitten in Ihren Abläufen",
    "subtitle": "Keine neue Software, keine Schulung, keine Umstellung.",
    "cards": [
      {
        "title": "Im Firmenchat",
        "text": "Gesprochen wird dort, wo Ihre Leute ohnehin schreiben: Webex, Microsoft Teams, Zoom, Slack. Eine Nachricht genügt."
      },
      {
        "title": "In Ihren Werkzeugen",
        "text": "Projektmanagement, Repositories, Ablagen: Gearbeitet wird in den Systemen, die da sind, nicht an ihnen vorbei."
      },
      {
        "title": "Vom Angebot bis zur Buchhaltung",
        "text": "Ein Prozess nach dem anderen, in Ihrem Tempo. Bei knappen Kapazitäten auch nur ein einzelnes Entwicklungspaket oder ein ganzes Projekt."
      }
    ]
  },
  "org": {
    "title": "Eine Belegschaft, organisiert wie ein Unternehmen",
    "subtitle": "Wir zwingen keinem Unternehmen eine starre Schablone auf: Für jede Unternehmensstruktur entwerfen wir ein individuelles Organigramm, vergeben klare Rollen und Verantwortlichkeiten und passen uns flexibel an. Jede Business Unit besteht aus KI-Mitarbeitern, die von Veridion orchestriert werden und bis zum [IDD](idd)-Human-in-the-Loop vollautomatisiert arbeiten — und wenn etwas noch nicht geht, entwickelt Veridion selbst neue KI.",
    "execKicker": "Koordinationsebene — vollautomatisiert bis zum IDD Human-in-the-Loop",
    "execTitle": "Individuelles Organigramm, klare Rollen und KI, die KI selbst weiterentwickelt.",
    "execText": "Unterhalb der menschlichen Entscheider laufen Koordinationsebene und Business Units aus KI-Mitarbeitern vollautomatisiert: Sie zerlegen Ziele, verteilen Arbeit auf klar definierte Rollen und Verantwortlichkeiten, lösen Probleme eigenständig und holen gezielte Freigaben vom Menschen ein. Der Mensch im Loop steuert über [Intent-Driven Development](idd) (IDD) — weit über Softwarecode hinaus als gemeinsame Führung von Mensch und KI über Absichten, Entscheidungen und Prüfszenarien. Und wann immer eine Fähigkeit fehlt, entwickelt Veridion eigenständig neue, beliebig komplexe KI-Systeme — KI entwickelt KI weiter.",
    "units": [
      {
        "name": "Softwareentwicklung",
        "text": "Verantwortet Software von der Anforderung bis zum Betrieb: Architektur, Code, Tests, Reviews, Pipelines und die Qualität dahinter."
      },
      {
        "name": "Elektronik & Firmware",
        "text": "Verantwortet die Hardware-Seite: Schaltungen, Firmware und die Wahl jedes Bauteils."
      },
      {
        "name": "Quantum Computing & Quantum-KI",
        "text": "Verantwortet die Forschung an Quantum Computing und Quanten-KI und macht aus belastbaren Ergebnissen Produkte."
      },
      {
        "name": "Vertrieb & Marketing",
        "text": "Verantwortet den Markt: beobachtet ihn, findet Zielkunden, erstellt Dossiers, entwirft Texte und Angebote. Den Abschluss macht ein Mensch."
      },
      {
        "name": "Produkte & Plattformbetrieb",
        "text": "Verantwortet Produkte und Betrieb: Strategie, Prioritäten, Releases, dazu Überwachung, Störungen und Kapazität der laufenden Plattform."
      },
      {
        "name": "Verwaltung & Finanzen",
        "text": "Verantwortet das Kaufmännische: Belege, Rechnungen, Verträge, Fristen, vorbereitet bis zur Unterschrift, und die bleibt bei Ihnen."
      }
    ]
  },
  "trust": {
    "title": "Worauf Sie sich verlassen können",
    "cards": [
      {
        "title": "Human-in-the-Loop & IDD weit über Code hinaus",
        "text": "Intent-Driven Development ([IDD](idd)) ist weit mehr als Softwareentwicklung: Es ist das, was der Mensch im Loop gemeinsam mit der KI über alle Unternehmensbereiche hinweg tut. Mensch und KI formulieren zusammen die Absicht (Intent), treffen verbindliche Entscheidungen (Decisions) und definieren prüfbare Szenarien (Scenarios), bevor die KI-Belegschaft in festen, planbaren Zyklen eigenständig ausführt und der Mensch gezielt freigibt."
      },
      {
        "title": "Spieltheoretisch optimierte Kommunikation",
        "text": "Das Projektmanagement und die Kommunikation der KI-Mitarbeiter sind spieltheoretisch optimiert, vom Einzelnen bis zur ganzen Business Unit: Gründlichkeit und begründeter Widerspruch zahlen sich aus; Durchwinken, Wiederholung und Verantwortungsschieben kosten. So setzt sich die beste Kommunikation durch."
      },
      {
        "title": "Erklärbar bis zur Quelle",
        "text": "Explainable AI ist hier Arbeitsprinzip, kein Zusatz: Jedes Ergebnis legt offen, woraus es entstanden ist, die Fundstellen im Firmenwissen, die Daten, den Rechenweg. Was keinen Beleg hat, wird nicht behauptet."
      },
      {
        "title": "Lernt eigenständig",
        "text": "Die eigenen Kennzahlen werden nach jedem Durchlauf gelesen, die eigenen Regeln daraufhin angepasst: Jedes laufende Projekt macht das Ganze besser."
      }
    ]
  },
  "daily": {
    "title": "Was heute schon übernommen wird",
    "subtitle": "Jeden Tag, quer durch das Unternehmen.",
    "items": [
      {
        "title": "Entwicklung",
        "text": "Code, Tests und Dokumentation aus festgehaltenen Entscheidungen. Modernisierung gewachsener Software mit Golden-Master- und Back-to-Back-Nachweis."
      },
      {
        "title": "Elektronik & Firmware",
        "text": "Datenblätter analysieren, Schaltungen als digitale Zwillinge simulieren, Firmware entwickeln und Bauteil-Alternativen bewerten, bevor etwas gefertigt wird, hardwarenah bis auf den Sensor."
      },
      {
        "title": "Quantenforschung",
        "text": "Den Stand der Technik lesen, reproduzierbare Experimente gegen klassische Vergleichsbasen aufbauen und auswerten, jedes Ergebnis nachvollziehbar festgehalten."
      },
      {
        "title": "Datenanalyse",
        "text": "SQL Server, MariaDB, MySQL und Oracle: typisierter Analyseplan, ausschließlich lesende Abfragen, Statistik aus der Laufzeitumgebung, Berichte aus einem versionierten Ergebnis."
      },
      {
        "title": "Verwaltung & Finanzen",
        "text": "Buchhaltung, Rechnungswesen und die Bürokratie einer GmbH: Belege lesen, zuordnen, ablegen; Entwürfe für Rechnungen und Verträge inklusive."
      },
      {
        "title": "Projekte & Aufgaben",
        "text": "Aus einem Meeting-Transkript werden ohne Umweg Aufgaben im Projektmanagement, und der Fortschritt läuft zurück: Das nächste Meeting beginnt beim aktuellen Stand."
      },
      {
        "title": "Firmenwissen",
        "text": "Eine Wissensbasis für Dokumente und eine Graphendatenbank, die Aufgaben, Entscheidungen, Personen und Systeme verknüpft: Zusammenhang über Wochen und Projektgrenzen hinweg."
      },
      {
        "title": "Recherche im Internet",
        "text": "Was das Firmenwissen nicht hat, wird recherchiert: gesucht, die besten Seiten gelesen, und am Ende steht ein Bericht, in dem jede Aussage ihre nummerierte Quelle hat."
      },
      {
        "title": "Sprache & Meetings",
        "text": "Die ganze Firma lässt sich mobil führen: Gesprochene Gespräche erledigen dieselben Aufgaben wie der Chat, auch unterwegs am Handy."
      },
      {
        "title": "Büroarbeit mit RoBuddy",
        "text": "RoBuddy deckt den Arbeitsplatz ab: Termine, E-Mails, Schulungen und Datenschutzfragen. Die Einheiten decken den Rest des Unternehmens."
      }
    ]
  },
  "operate": {
    "title": "Betrieb",
    "cards": [
      {
        "title": "On-premises oder eigene Cloud",
        "text": "Vorab rechnen wir gemeinsam, welche Prozesse sich lohnen: Return on Investment und Gesamtkosten liegen offen. Betrieben wird auf Ihrer Hardware oder in Ihrer eigenen Cloud, ohne dass ein Dokument das Haus verlässt."
      },
      {
        "title": "Bei uns",
        "text": "Die pAIoneer Labs GmbH ist von Grund auf so aufgebaut: unsere Projekte, unser Firmenwissen und unsere Verwaltung laufen darüber. Den [Trading-Assistenten](finance) unserer Plattform entwickelt die Organisation selbst, und im Chat ist sie dessen KI."
      }
    ]
  },
  "cta": {
    "title": "Anfrage",
    "subtitle": "Als Server-Software in Ihrer Infrastruktur. Den Preis nennen wir auf Anfrage.",
    "button": "Anfrage senden",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
